import { Table, TableBody, TableCell, TableFooter, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { ICommissionSummary } from '@/data/referral'
import { formatTokenAmount, formatUnits } from '@/utils'

import { useTranslation } from 'react-i18next'

interface TokenBalanceTableProps {
  commissionSummary?: ICommissionSummary
}
export const TokenBalanceTable = ({ commissionSummary }: TokenBalanceTableProps) => {
  const { t } = useTranslation()
  return (
    <Table>
      <TableHeader>
        <TableRow className='border-none hover:bg-transparent'>
          <TableHead className='text-white-48  px-0 pb-4'>{t('title.TOKEN')}</TableHead>
          <TableHead className='text-white-48  px-6 pb-4'>{t('title.TOKEN_AMOUNT')}</TableHead>
          <TableHead className='text-white-48  px-0 pb-4 text-right'>{t('title.EST_VALUE_IN_USDT')}</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {commissionSummary?.commissionsByToken?.map((reward) => (
          <TableRow key={reward.token.id} className='border-none hover:bg-transparent'>
            <TableCell className='pt-0 pb-4 px-0 flex items-center gap-2'>
              <img src={reward.token.tokenLogoUri} alt={reward.token.tokenSymbol} className='size-5' loading='lazy' />
              {reward.token.tokenSymbol}
            </TableCell>
            <TableCell className='pt-0 pb-4 px-6'>
              {formatTokenAmount(
                formatUnits(reward.balance, reward.token.tokenDecimals),
                reward.token.tokenSymbol || ''
              )}{' '}
              {reward.token.tokenSymbol}
            </TableCell>
            <TableCell className='pt-0 pb-4 px-0 text-right'>
              {formatTokenAmount(reward.availableUsd, 'USDT')} USDT
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <TableFooter className='bg-transparent border-t border-white-10'>
        <TableRow className='hover:bg-transparent'>
          <TableCell className='pt-4 pb-0 px-0' colSpan={3}>
            {t('title.REWARDS_CONSOLIDATED_NOTE')}
          </TableCell>
        </TableRow>
      </TableFooter>
    </Table>
  )
}
